module.exports = __webpack_public_path__ + "static/media/img10.80da8779.jpg";